import { makeStyles, Theme } from "@material-ui/core/styles";

export const lessonsInCollectiblesStyles = makeStyles((theme: Theme) => ({
  header: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    color: "#0F172A",
    marginTop: "40px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  infoIcon: {
    fontSize: theme.typography.pxToRem(19),
    fontWeight: 300,
    lineHeight: theme.typography.pxToRem(19),
    color: "#000",
    marginLeft: 10,
  },
  contentContainer: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-evenly",
  },
  viewMoreBtn: {
    marginTop: "40px",
    fontfamily: "Inter !important",
    alignSelf: "right",
    justifySelf: "right",
    fontWeight: 600,
    color: "#F15A28",
    border: "none",
    backgroundColor: "transparent",
    fontSize: theme.typography.pxToRem(16),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  emptyState: {
    width: "100%",
  },
  container: {
    display: "flex",
    flexBasis: "267px",
    height: "100%",
  },
  button: {
    marginBlockStart: 25,
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
  },
}));
